import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, TextField } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { IFramePage } from './components/IFramePage';
import { ReportsQuery } from '../../services/query';
import './SsrsPage.scss';

export const SsrsPage: FC<any> = () => {
    const [searchedReport, setSearchedReport] = useState<any>();
    const [openEditModal, setOpenEditModal] = useState(false);
    const [searchedReports, setSearchedReports] = useState('');
    const [reports, setReports] = useState([]);
    const [report, setReport] = useState<any>();

    const { t } = useTranslation();

    const onModalEditClose = () => setOpenEditModal(false);
    const onModalEditOpen = () => setOpenEditModal(true);

    const GetReports = () => {
        ReportsQuery.GetListOfSelfReportsListItem()
            .then((res: any) => {
                if (res) {
                    console.info(res);
                    let parseData = res.data.map((item: any) => {
                        return {
                            reportId: item.reportId || '-',
                            reportTitle: item.reportTitle || '-',
                            reportUri: item.reportUri || '-',
                        };
                    });

                    setReports(parseData);
                    setSearchedReport(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    useEffect(() => {
        GetReports();
    }, []);
    const requestSearchMpConfig = (searchedVal: any) => {
        setSearchedReports(searchedVal.target.value);
        let filteredRoles = searchedReport.filter(
            (o: any) => o.reportTitle.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        setReports(filteredRoles);
    };
    const columns: ExtendedGridColDef[] = [
        { field: 'reportId', headerName: 'ID', width: 90, flex: 1, hide: true },
        {
            field: 'reportTitle',
            headerName: t('ssrsPage.reportName'),
            width: 150,
            flex: 1,
            renderCell: (params) => {
                const onclick = () => {
                    setReport(params.row);
                    console.info(params.row);
                    onModalEditOpen();
                };
                return (
                    <div>
                        <a className="cursorPointer" onClick={onclick}>
                            {params.row.reportTitle}
                        </a>
                    </div>
                );
            },
        },
    ];

    return (
        <SCUIContent>
            <IFramePage selectedRow={report} open={openEditModal} onClose={onModalEditClose} />
            <Grid container direction="row">
                <Grid
                    size={{
                        lg: 10,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <h1 className="headtxt">{t('general.reports')} </h1>
                </Grid>
                <Grid
                    sx={{ marginBottom: 1, marginTop: 1 }}
                    size={{
                        xs: 12,
                        sm: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <TextField
                        label={'Key'}
                        value={searchedReports}
                        onChange={(searchVal) => requestSearchMpConfig(searchVal)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <SCUICustomDataGrid
                        rows={reports}
                        randomId
                        columns={columns}
                        initialState={{
                            sorting: {
                                sortModel: [
                                    {
                                        field: 'id',
                                        sort: 'asc',
                                    },
                                ],
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
